"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageUserLanguage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsSelect = require("../../components/DmsSelect/DmsSelect");
var _material = require("@mui/material");
var _Locales = require("../../constants/Locales");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
var _DmsForm = require("../../components/DmsForm/DmsForm");
var _DmsTokenHook = require("../../components/DmsTokenHook/DmsTokenHook");
var _LanguageContext = require("../../context/LanguageContext");
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPageUserLanguage component represents a page for managing user language settings.
 * It renders a page layout using DmsPage and includes a DmsAltBox component for displaying
 * language settings related to user preferences.
 * 
 * @returns {JSX.Element} DmsPageUserLanguage component.
 */
const DmsPageUserLanguage = () => {
  const {
    language: contextLanguage,
    setLanguage: setContextLanguage
  } = (0, _react.useContext)(_LanguageContext.LanguageBaseContext);
  const [language, setLanguage] = (0, _react.useState)(null);
  const [tempLanguage, setTempLanguage] = (0, _react.useState)(null);
  const lastLanguage = (0, _react.useRef)(language);
  const lastTempLanguage = (0, _react.useRef)(tempLanguage);
  const [loading, setLoading] = (0, _react.useState)(true);
  const token = (0, _DmsTokenHook.getToken)();
  const options = Object.entries(_Locales.LOCALES_FLAG).map(_ref => {
    let [label, value] = _ref;
    return {
      value,
      label
    };
  });
  const handleChangeLanguage = async newLang => {
    setContextLanguage(newLang);
    setTempLanguage(newLang);
  };
  (0, _react.useEffect)(() => {
    return () => {
      if (lastLanguage.current !== lastTempLanguage.current) {
        setContextLanguage(lastLanguage.current);
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    lastLanguage.current = language;
    lastTempLanguage.current = tempLanguage;
  }, [language, tempLanguage]);
  const handleSubmit = async formData => {
    const response = await (0, _DmsFetch.fetchData)("/user/language/".concat(token.login), 'PUT', true, formData);
    if (response.status == _HttpStatus.HTTP_STATUS.OK_200) {
      setLanguage(tempLanguage);
      setContextLanguage(tempLanguage);
    }
    return response;
  };
  (0, _react.useEffect)(() => {
    const fetchUserLanguage = async () => {
      try {
        var _data$data$user_langu, _data$data, _data$data$user_langu2, _data$data2;
        const {
          data
        } = await (0, _DmsFetch.fetchData)("/user/language/".concat(token.login), 'GET', true);
        setLanguage((_data$data$user_langu = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.user_language) !== null && _data$data$user_langu !== void 0 ? _data$data$user_langu : '-');
        setTempLanguage((_data$data$user_langu2 = data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.user_language) !== null && _data$data$user_langu2 !== void 0 ? _data$data$user_langu2 : '-');
      } catch (error) {
        console.error('Error fetching user language:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserLanguage();
  }, []);
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h6",
      style: {
        marginLeft: '10px'
      }
    }, _reactIntlUniversal.default.get("LoadingSettingsdots").d("Loading Settings...")));
  }
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Language Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: "1.1rem"
    }
  }, _reactIntlUniversal.default.get("UserLanguage").d("User Language"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm.Body, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "user_language",
    label: _reactIntlUniversal.default.get("LanguageSettings").d("Language Settings"),
    options: options,
    value: language,
    onChange: e => handleChangeLanguage(e),
    fullWidth: true
  }))))))));
};
exports.DmsPageUserLanguage = DmsPageUserLanguage;